import React from 'react';
import './Operations.css'; // Reuse same styling

const operations = [
    { title: 'Hatchery', image: '/images/operation1.jpg' },
    { title: 'Farms', image: '/images/operation2.jpg' },
    { title: 'Feed', image: '/images/operation3.jpg' },
    { title: 'Processing Plants', image: '/images/operation4.jpg' },
    { title: 'Exports', image: '/images/operation5.jpg' },
    { title: 'Distribution', image: '/images/operation6.png' }
  ];
function Operations() {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <div className="about-hero-image">
        <img src="/images/operations-hero.jpg" alt="Operations Overview" />
      </div>

      {/* Operations Grid */}
      <section className="operations-grid-section">
        <h2 className="section-title">OPERATIONS</h2>
        <p className="operations-desc">
          The company’s ethos strongly relies on an integrated work cycle with operations in
          hatchery, farms, feed, processing plants, exports & distribution.
        </p>
        <div className="operations-grid">
          {operations.map((op, index) => (
            <div className="operation-tile" key={index}>
              <img src={op.image} alt={op.title} />
              <div className="operation-overlay">
                <span>{op.title}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Content Below Grid */}
      <section className="about-content-section">
        <h2>Our Integrated Aquaculture System</h2>
        <p>
          At Sharanga Aqua Farms, we implement a seamless integration across every phase of aquaculture
          — from hatchery operations to international product distribution.
        </p>
        <p>
          Farms are managed with real-time environmental monitoring systems to maintain water quality and feed balance.
        </p>
        <p>
          Our feed is formulated to match the nutritional requirements of the species we cultivate. Every batch
          is tested to ensure quality and digestibility, maximizing yield and growth rates.
        </p>
      </section>
    </div>
  );
}

export default Operations;
